module.exports = __webpack_public_path__ + "img/MAC1133_R.8f051bf8.png";